import { render, staticRenderFns } from "./countriesforphonecode.vue?vue&type=template&id=6d450b94&"
import script from "./countriesforphonecode.vue?vue&type=script&lang=js&"
export * from "./countriesforphonecode.vue?vue&type=script&lang=js&"
import style0 from "./countriesforphonecode.vue?vue&type=style&index=0&id=6d450b94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports